import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivacyPolicy from '@pages/PrivacyPolicy';
import Home from '@pages/Home';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="politicas-de-privacidade" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;